import type { ReactNode } from 'react';

export interface SectionHeadProps {
  /** Section label — rendered mono-uppercase. */
  title: ReactNode;
  /** Count badge (e.g. number of items). */
  tag?: string;
  /** Trailing action(s), rendered after the rule (e.g. a "+ New" button). */
  action?: ReactNode;
  /**
   * @deprecated The compact section head no longer renders an accent marker
   * letter. Accepted for backward-compat with existing callers; ignored.
   */
  marker?: string;
}

/**
 * Compact section header: mono-uppercase label · count pill · hairline rule ·
 * optional trailing action. Used by the project canvas sections (Epics, Work
 * Items, Documents, Mockups).
 */
export function SectionHead({ title, tag, action }: SectionHeadProps) {
  return (
    <div className="pn-section-head">
      <h2>{title}</h2>
      {tag !== undefined ? <span className="pn-section-count">{tag}</span> : null}
      <span className="pn-section-rule" />
      {action ? <div className="pn-section-action">{action}</div> : null}
    </div>
  );
}
